module.exports = __webpack_public_path__ + "img/fan.91995988.png";